import { Card, CardActions as CardActionsComponent, Typography, } from '@mui/material';
import styled from 'styled-components';
export const Container = styled(Card) `
  &&.MuiCard-root {
    ${({ withoutshadow }) => withoutshadow === 'true' && 'box-shadow: unset;'};
  }
  && {
    ${({ borderradius }) => borderradius && `border-radius: ${borderradius}`};
    ${({ height }) => height && `height: ${height}`};
    ${({ width }) => width && `width: ${width}`};
    ${({ maxwidth }) => maxwidth && `max-width: ${maxwidth}`};
    ${({ nobottom }) => nobottom === 'true' && `border-bottom: 0;`};
    display: flex;
    ${({ noborder }) => noborder === 'true' && `border: 0`};
    flex-direction: column;
    ${({ noflex }) => noflex === 'false' && `flex: 1;`};
    & > div {
      ${({ flexchild }) => flexchild === 'true' && `flex: 1`};
    }
    ${({ overflow }) => overflow && `overflow: ${overflow}`};
  }
`;
export const Header = styled.div `
  display: flex;
  padding: 1rem;
  justify-content: space-between;
  align-items: center;
  min-height: 48px;
`;
export const ActionHeader = styled.div `
  display: flex;
  align-items: center;

  h3 {
    margin-right: 0.5rem;
  }
`;
export const ChildrenContainer = styled.div `
  flex: 1;
  ${(props) => props.childoverflowy && `overflow-y: auto;`}
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
`;
export const HeaderTitle = styled(Typography) `
  ${({ truncatedtitle, containerwidth }) => truncatedtitle === 'true'
    ? {
        width: containerwidth,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    }
    : {}}
`;
export const CardActions = styled(CardActionsComponent) `
  && {
    padding: 1rem;
    justify-content: flex-end;
  }
`;
